import api from 'api'

export type InvoiceIssueCompany = {
  id: number
  name: string
}

export type MissingDepartmentPosition = {
  id: number
  name: string
  shiftCount: number
}

export type MissingDepartmentIssue = {
  company: InvoiceIssueCompany
  positions: MissingDepartmentPosition[]
  shiftCount: number
}

export type StaleUnfinalizedCharge = {
  id: number
  shiftId: number
  shiftEndedAt: string
}

export type StaleUnfinalizedChargesIssue = {
  company: InvoiceIssueCompany
  charges: StaleUnfinalizedCharge[]
}

export type MissedInvoiceCharge = {
  id: number
  createdAt: string
  shiftId: number | null
}

export type InvoiceCycleType = 'standard' | 'weekly'

export type DayOfWeek =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday'

export type MissedInvoiceChargesIssue = {
  company: InvoiceIssueCompany
  cycleType: InvoiceCycleType
  weekStartDay: DayOfWeek | null
  lastInvoiceRunAt: string
  charges: MissedInvoiceCharge[]
}

export type InvoiceIssuesResponse = {
  missingDepartment: MissingDepartmentIssue[]
  staleUnfinalizedCharges: StaleUnfinalizedChargesIssue[]
  missedInvoiceCharges: MissedInvoiceChargesIssue[]
}

export const getInvoiceIssues = async (): Promise<InvoiceIssuesResponse> => {
  const response = await api.get<InvoiceIssuesResponse>('/admin/invoice_issues')
  return response.data
}
